import { Component, OnInit } from '@angular/core';
import { AbstractControl, FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ComponentBase } from '../../../../core/_infrastructure/classes/componentBase';
import { ConfirmationService } from 'primeng/api';
import { NotificationService } from '../../../../core/_infrastructure/classes/services/notification.service';
import { AuthService } from '../../../../core/_infrastructure/classes/services/auth.service';
import { ExceptionManager } from '../../../../core/_infrastructure/classes/handlers/exceptionManager';
import { NavMenuService } from '../../../../core/components/navmenu/navmenu.service';
import { SolicitudService } from '../../datosbasicos/datosbasicos.service';
import { SolicitudViewModel, TImportadorLugarDestinoViewModel, TImportadorViewModel } from '../../datosbasicos/datosbasicos.types';
import { EnumIdsTcPais, TcPaisUsaCodigoPostal } from '../../../../core/_infrastructure/types/common';
import { HttpParams } from '@angular/common/http';
import { GlobalService } from '../../../../core/_infrastructure/classes/services/global.service';
import {
    EnumCodigosTwTcAcciones,
    EnumIdsTcEstadoSolicitud,
    EnumIdsTcTipoMedioTransporte,
    EnumIdsTcTipoSolicitud,
    EnumIdsTwTcConfiguracionImportadorYlugarDestinoPorSolicitud,
    EnumIdsTwTcTipoClonacion,
    EnumIdsTwTcTipoTransbordo,
} from '../../types/enum';
import { ProductosService } from '../../productos/productos.service';
import { ImportadorLugarDestinoService } from '../importador-lugardestino.service';
import { Subject, catchError, combineLatest, map, of, tap } from 'rxjs';
import { SolicitudProductosViewModel } from '../../productos/productos.types';
import { ConfiguracionImportadorLugarDestinoSolicitudViewModel } from '../importador-lugardestino.types';

@Component({
    selector: 'app-importador-lugardestino-wrapper',
    templateUrl: './importador-lugardestino-wrapper.component.html',
})
export class ImportadorLugarDestinoWrapperComponent extends ComponentBase implements OnInit {
    formGroup: FormGroup;

    visibilitySpinner = false;

    laHeGrabadoYo = false;

    IdSolicitud: number;
    IdTipoSolicitud: number;
    IdTipoSolicitudDescripcion: string;
    CodigoTipoSolicitud: string;
    IdEstadoSolicitud: number;
    IdEstadoSolicitudDescripcion: string;
    IdSolicitante: number | null;
    IdSolicitanteAdministrativo: number | null;
    IdEstadoChedPp: number | null;
    IdEstadoChedPpDescripcion: string;
    IdResultadoEnvioMuestrasLaboratorio: number | null;
    IdResultadoEnvioMuestrasLaboratorioDescripcion: string;

    // Inputs
    solicitud: SolicitudViewModel;
    habilitarGuardar = false;
    esPasajeros = false;
    esPredua = false;
    esPrevia = false;
    esTransitoDirecto = false;
    esTransbordo = false;
    esTraslado = false;
    esClonada = false;
    esProductosFitosanitarios = false;
    esImportadorExtranjero: boolean | null = false;
    esCanarias = false;
    esClonFinalizaTraslado = false;
    esParticionRp = false;
    esReImportacion = false;
    esSolicitudGrabador = false;
    enviada = false;
    tieneLugarDestinoImpor = false;
    campoObligatorio = true;
    readonlyImporExtr = true;
    usaCodigoPostalPaisImportador = true;
    usaCodigoPostalPaisImpLugarDestino = true;
    habilitarBuscarOperador = true;
    habilitarBuscarOperadorImpLugarDestino = true;

    isConfiguracionPcfCanariasNoTraces = false;
    isCanariasPifCanarias = false;
    listPaisImportador: TcPaisUsaCodigoPostal[];
    tieneProductos = false;
    idPaisTraslado: number;

    // Booleanos para saber qué mostrar en los componentes de "Importador" y "Lugar de Destino"
    edicionManual = false;
    validacionRegistroImportadores = false;
    validacionEupoEurpo = false;
    validacionRegistroSanitario = false;

    idConfiguracion: number;

    solicitudProductos: SolicitudProductosViewModel;

    paisRequiredMedioTransporte = false;

    private formularioCargado$: Subject<boolean> = new Subject();
    private solicitudCargada$: Subject<boolean> = new Subject();

    vm$ = combineLatest([this.formularioCargado$, this.solicitudCargada$])
        .pipe(
            map(([formularioCargado, solicitudCargada]) => {
                if (formularioCargado && solicitudCargada) {
                    if (!this.isSolicitante && !this.isGrabador) {
                        this.DisableControlsConsulta();
                    } else if (
                        (this.isSolicitante || this.isGrabador) &&
                        this.solicitud.IdEstadoSolicitud !== EnumIdsTcEstadoSolicitud.ID_BORRADOR &&
                        this.solicitud.IdEstadoSolicitud !== EnumIdsTcEstadoSolicitud.ID_REVISION_SOLICITANTE
                    ) {
                        this.DisableControlsConsulta();
                    }
                }
                return {};
            }),
        )
        .subscribe();

    private activatedRoute$ = this.activatedRoute.paramMap.subscribe(params => {
        const idSolicitud = params.get('id');
        if (idSolicitud) {
            this.IdSolicitud = parseInt(idSolicitud);
            if (this.IdSolicitud) {
                this.getSolicitud();
                this.productosService.getSolicitudProductos(this.IdSolicitud).subscribe(solicitudProductos => {
                    if (solicitudProductos.TProductoSolicitudCollection !== null && solicitudProductos.TProductoSolicitudCollection.length !== 0) {
                        this.tieneProductos = true;
                        this.solicitudProductos = solicitudProductos;
                    }
                });
            }
        }
    });

    constructor(
        protected notificationService: NotificationService,
        protected authService: AuthService,
        protected exceptionHandler: ExceptionManager,
        private activatedRoute: ActivatedRoute,
        private fb: FormBuilder,
        private router: Router,
        private confirmationService: ConfirmationService,
        private navMenuService: NavMenuService,
        private globalService: GlobalService,
        private solicitudService: SolicitudService,
        private productosService: ProductosService,
        private importadorLugarDestinoService: ImportadorLugarDestinoService,
    ) {
        super(authService, notificationService, exceptionHandler);
    }

    ngOnInit(): void {
        this.buildForm();
    }

    private buildForm(): void {
        this.formGroup = this.fb.group({
            basic: this.fb.group({
                // Importador
                NIF: ['', Validators.required],
                NRegistro: '',
                RefTraces: '',
                TipoRefTraces: '',
                OperadorTraces: '',
                TipoOperador: '',
                Nombre: '',
                Direccion: ['', Validators.required],
                Localidad: ['', Validators.required],
                CodigoPostalImportador: ['', Validators.required],
                IdPaisImportador: null,
                IdRegistroSanitario: null,
                RegistroSanitario: '',
                RazonSocialRegistroSanitario: '',
                DireccionRegistroSanitario: '',
                MunicipioRegistroSanitario: '',
                ProvinciaRegistroSanitario: '',

                // Importador Lugar Destino
                NIFImpLugarDestino: '',
                NRegistroImpLugarDestino: '',
                RefTracesImpLugarDestino: '',
                TipoRefTracesImpLugarDestino: '',
                OperadorTracesImpLugarDestino: '',
                TipoOperadorImpLugarDestino: '',
                NombreImpLugarDestino: '',
                DireccionImpLugarDestino: '',
                LocalidadImpLugarDestino: '',
                CodigoPostalImpLugarDestino: '',
                IdPaisImpLugarDestino: null,
                IdRegistroSanitarioImpLugarDestino: null,
                RegistroSanitarioImpLugarDestino: '',
                RazonSocialRegistroSanitarioImpLugarDestino: '',
                DireccionRegistroSanitarioImpLugarDestino: '',
                MunicipioRegistroSanitarioImpLugarDestino: '',
                ProvinciaRegistroSanitarioImpLugarDestino: '',
            }),
        });

        this.form = this.formGroup;
    }

    onUpdateForm(actualizado: boolean) {
        if (actualizado) {
            this.formularioCargado$.next(true);
        }
    }

    private getSolicitud() {
        // Para saber si se actúa como Inspector o Grabador
        let params = new HttpParams();
        params = params.append('idSolicitud', this.IdSolicitud.toString());
        params = params.append('idUsuario', this.loggedInUser!.Id.toString());

        this.solicitudService.isSolicitudUsuario(params).subscribe(resultIsGrabada => {
            this.laHeGrabadoYo = resultIsGrabada;

            this.solicitudService.getSolicitud(this.IdSolicitud).subscribe(result => {
                this.navMenuService.currentSolicitudImportacion = result;
                this.solicitud = result;

                let params = new HttpParams();
                params = params.append('id', this.solicitud.IdPuntoInspeccion.toString());
                params = params.append('esimportacion', 'true');

                this.IdEstadoSolicitud = this.solicitud.IdEstadoSolicitud;
                this.IdTipoSolicitud = this.solicitud.IdTipoSolicitud;
                this.esCanarias = this.solicitud.TcTipoSolicitud.Id == EnumIdsTcTipoSolicitud.ID_CANARIAS;
                this.isCanariasPifCanarias = this.solicitud.IsCanariasPifCanarias;
                this.esTraslado = this.solicitud.IdTipoSolicitud == EnumIdsTcTipoSolicitud.ID_TRASLADO;
                this.esTransitoDirecto = this.solicitud.IdTipoSolicitud == EnumIdsTcTipoSolicitud.ID_TRANSITO_DIRECTO;
                this.esTransbordo = this.solicitud.IdTipoSolicitud == EnumIdsTcTipoSolicitud.ID_TRANSBORDO;
                this.esPasajeros = this.solicitud.IdTipoSolicitud == EnumIdsTcTipoSolicitud.ID_PASAJEROS;
                this.esProductosFitosanitarios = this.solicitud.IdTipoSolicitud == EnumIdsTcTipoSolicitud.ID_PROD_FITOSANITARIOS;
                this.esClonada =
                    this.solicitud.TwSolicitudJerarquia != null && this.solicitud.TwSolicitudJerarquia.IdTipoClonacion == EnumIdsTwTcTipoClonacion.ID_CLONACION
                        ? true
                        : false;
                this.esClonFinalizaTraslado =
                    this.solicitud.TwSolicitudJerarquia != null &&
                    this.solicitud.TwSolicitudJerarquia.IdTipoClonacion == EnumIdsTwTcTipoClonacion.ID_FINALIZA_TRASLADO
                        ? true
                        : false;
                this.esParticionRp =
                    this.solicitud.TwSolicitudJerarquia != null && this.solicitud.TwSolicitudJerarquia.IdTipoClonacion == EnumIdsTwTcTipoClonacion.ID_PARTICION
                        ? true
                        : false;
                this.IdTipoSolicitudDescripcion = this.solicitud.TcTipoSolicitud.Descripcion;
                this.CodigoTipoSolicitud = this.solicitud.TcTipoSolicitud.Codigo;
                this.IdEstadoSolicitudDescripcion = this.solicitud.TcEstadoSolicitud.Descripcion;
                this.IdResultadoEnvioMuestrasLaboratorio = this.solicitud.IdResultadoEnvioMuestrasLaboratorio;
                this.IdResultadoEnvioMuestrasLaboratorioDescripcion = this.solicitud.DescripcionIdResultadoEnvioMuestrasLaboratorio;
                this.IdEstadoChedPp = this.solicitud.IdEstadoChedPp;
                this.IdEstadoChedPpDescripcion = this.solicitud.IdEstadoChedPpDescripcion;
                this.IdSolicitante = this.solicitud.IdUsuarioSolicitante;
                this.IdSolicitanteAdministrativo = this.solicitud.IdUsuarioSolicitanteAdministrativo;
                this.esPredua = this.solicitud.TwTcSubTipoSolicitud != null && this.solicitud.TwTcSubTipoSolicitud.EsPreDua;
                this.esImportadorExtranjero = this.solicitud.EsExtranjero;
                this.esPrevia = this.solicitud.EsPrevia;
                this.esReImportacion = this.solicitud.EsReImportacion;
                this.paisRequiredMedioTransporte = this.solicitud.TMedioTransporte.IdMedioTransporte == EnumIdsTcTipoMedioTransporte.ID_AVION ? false : true;
                this.enviada = this.solicitud.Codigo != null && this.solicitud.Codigo.length > 0;
                this.esSolicitudGrabador = this.solicitud.TSolicitudAdministrativo != null;

                // Si tiene Lugar Destino (Importación)
                this.tieneLugarDestinoImpor = this.solicitud.TcTipoSolicitud.LugarDestinoImportador;

                // Aquí se realiza la funcionalidad para saber qué mostrar en los componentes de "Importador" y "Lugar de Destino". Hay que aplicar la configuración más restrictiva en caso de que haya más de una
                if (this.tieneProductos) {
                    let allConfiguraciones: ConfiguracionImportadorLugarDestinoSolicitudViewModel[];

                    this.productosService.getAllConfiguraciones(this.solicitudProductos.TProductoSolicitudCollection).subscribe(res => {
                        allConfiguraciones = res;

                        this.edicionManual = allConfiguraciones.some(conf => conf.EdicionManual === true);
                        this.validacionRegistroImportadores = allConfiguraciones.some(conf => conf.ValidacionRegistroImportadores === true);
                        this.validacionEupoEurpo = allConfiguraciones.some(conf => conf.ValidacionEupoEurpo === true);
                        this.validacionRegistroSanitario = allConfiguraciones.some(conf => conf.ValidacionRegistroSanitario === true);

                        if (this.esPrevia) {
                            this.validacionRegistroSanitario = false;
                        }

                        const idsValidos = [
                            EnumIdsTwTcConfiguracionImportadorYlugarDestinoPorSolicitud.ID_NOHIGIENE_NOCHEDPP_CANARIAS_IMPNACIONAL,
                            EnumIdsTwTcConfiguracionImportadorYlugarDestinoPorSolicitud.ID_HIGIENE_NOCHEDPP_CANARIAS_IMPNACIONAL,
                        ];

                        this.isConfiguracionPcfCanariasNoTraces = allConfiguraciones.every(conf => idsValidos.includes(conf.Id!));
                    });
                }

                if (this.esPasajeros || this.esProductosFitosanitarios || (this.isCanariasPifCanarias && this.esPredua && this.esImportadorExtranjero)) {
                    this.readonlyImporExtr = false;
                }

                //Si soy Grabador
                if (this.isGrabador && this.solicitud.IdEstadoSolicitud === EnumIdsTcEstadoSolicitud.ID_REVISION_SOLICITANTE) {
                    this.habilitarGuardar =
                        this.loggedInUser!.getAction(EnumCodigosTwTcAcciones.GUARDAR_SOLICITUD, this.solicitud.IdEstadoSolicitud).Visible && this.laHeGrabadoYo;
                } else {
                    this.habilitarGuardar = this.loggedInUser!.getAction(EnumCodigosTwTcAcciones.GUARDAR_SOLICITUD, this.solicitud.IdEstadoSolicitud).Visible;
                }

                this.solicitud.VieneDePreviaAceptada = this.solicitud.TPreviaInspector?.Aceptada;

                // Si es Re-Importación
                if (this.esReImportacion) {
                    this.IdTipoSolicitudDescripcion += ' - Re-Importación';
                }

                // Si es Previa
                if (this.esPrevia) {
                    if (
                        this.solicitud.IdEstadoSolicitud != EnumIdsTcEstadoSolicitud.ID_PREVIA_ACEPTADA &&
                        this.solicitud.IdEstadoSolicitud != EnumIdsTcEstadoSolicitud.ID_PREVIA_PENDIENTE
                    ) {
                        this.IdTipoSolicitudDescripcion += ' - Previa';
                    }

                    // Si ya la ha aceptado el inspector hay que validar como si ya no fuera PREVIA
                    if (this.solicitud.IdEstadoSolicitud != EnumIdsTcEstadoSolicitud.ID_PREVIA_ACEPTADA && !this.enviada) {
                        this.campoObligatorio = false;
                    }
                    if (this.solicitud.IdEstadoSolicitud == EnumIdsTcEstadoSolicitud.ID_PREVIA_PENDIENTE) {
                        this.campoObligatorio = false;
                    }
                }

                // LoadTransitoDirecto() y LoadTransbordo()
                if (this.esTransitoDirecto || this.esTransbordo) {
                    this.readonlyImporExtr = false;
                }

                // LoadTraslado()
                if (this.esTraslado) {
                    this.idPaisTraslado = this.solicitud.TwTraslado?.IdPaisTraslado;
                }

                // LoadPreduaDatos();
                if (this.solicitud.Mrn !== '' && this.solicitud.Mrn !== null && this.solicitud.Mrn !== undefined) {
                    this.solicitudService.getDatosPredua(this.solicitud.Mrn).subscribe(s => {
                        if (s != null) {
                            if (this.isCanariasPifCanarias && this.esImportadorExtranjero) {
                                this.readonlyImporExtr = false;
                            }
                        }
                    });
                }

                if (!this.esImportadorExtranjero && this.tieneLugarDestinoImpor) {
                    this.usaCodigoPostalPaisImpLugarDestino = true; // Esta variable se usa en el html para la Label
                } else if (!this.esImportadorExtranjero && !this.tieneLugarDestinoImpor) {
                    this.usaCodigoPostalPaisImportador = true; // Esta variable se usa en el html para la Label
                }

                if (this.isCanariasPifCanarias && this.esPredua && this.esImportadorExtranjero) {
                    this.readonlyImporExtr = false;
                }

                if (!this.esTransitoDirecto && !this.esTransbordo) {
                    // Si 'tieneLugarDestinoImpor' va a entrar por aqui por el tipo
                    this.globalService.getAllPaisesUeTcUsaCodigoPostal().subscribe(res => {
                        this.listPaisImportador = res;
                    });
                } else {
                    if (this.esTransitoDirecto) {
                        // Tránsitos Directos
                        // RDLF: 29/10/24 se añade España para los Tránsitos Directos (tarea 145949)

                        this.globalService.getAllPaisesNoUeConSpainTcUsaCodigoPostal().subscribe(res => {
                            this.listPaisImportador = res;

                            let idPais: number;
                            if (this.form.controls['IdPaisImportador']?.value === null || this.form.controls['IdPaisImportador']?.value === undefined) {
                                idPais = this.solicitud.TLugarMercancia.IdPaisDestino!;
                            } else {
                                idPais = this.form.controls['IdPaisImportador']?.value;
                            }

                            let seleccionado = this.listPaisImportador?.find(x => x.Id == idPais);

                            if (seleccionado != null && seleccionado != undefined) {
                                this.habilitarBuscarOperador = (<TcPaisUsaCodigoPostal>seleccionado).EsUnionEuropea && !this.esPasajeros;
                            }
                        });
                    } else {
                        // Transbordos

                        if (this.solicitud.TwTransbordo.IdTipoTransbordo == EnumIdsTwTcTipoTransbordo.ID_A_TERCER_PAIS) {
                            // A Tercer País
                            // RDLF: Tomás pide que estos paises, para estas solicitudes, sean NO UE (02/11/2023)

                            this.globalService.getAllPaisesNoUeTcUsaCodigoPostal().subscribe(res => {
                                this.listPaisImportador = res;

                                let idPais: number;
                                if (this.form.controls['IdPaisImportador']?.value === null || this.form.controls['IdPaisImportador']?.value === undefined) {
                                    idPais = this.solicitud.TLugarMercancia.IdPaisDestino!;
                                } else {
                                    idPais = this.form.controls['IdPaisImportador']?.value;
                                }

                                let seleccionado = this.listPaisImportador?.find(x => x.Id == idPais);

                                if (seleccionado != null && seleccionado != undefined) {
                                    this.habilitarBuscarOperador = (<TcPaisUsaCodigoPostal>seleccionado).EsUnionEuropea && !this.esPasajeros;
                                }
                            });
                        } else {
                            // A PCF_UE
                            this.globalService.getAllPaisesTcUsaCodigoPostal().subscribe(res => {
                                this.listPaisImportador = res;
                                this.habilitarBuscarOperador = false;
                            });
                        }
                    }
                }

                // Si es Pasajeros
                if (this.esPasajeros) {
                    this.habilitarBuscarOperador = false;
                }

                if (this.nombreImportadorRequired) {
                    this.addValidator('Nombre', Validators.required);
                }

                this.solicitudCargada$.next(true);
            });
        });
    }

    onDeleteCodigoConfeccionImportacion($event: number): void {
        this.confirmationService.confirm({
            message: 'Va a eliminar todos los datos correspondientes al Registro Sanitario del Importador, ¿desea continuar?',
            accept: () => {
                this.deleteDeleteCodigoConfeccionImportacion($event);
            },
        });
    }

    private deleteDeleteCodigoConfeccionImportacion(idRegistroSanitario: number): void {
        this.importadorLugarDestinoService
            .deleteRegistroSanitarioByIdSolicitudAsync(idRegistroSanitario)
            .pipe(
                tap(() => {
                    this.getSolicitud();
                    this.addSuccessMessage('El Registro Sanitario ha sido eliminado con éxito');
                }),
                catchError(error => {
                    this.catchServerError(error);
                    return of(null);
                }),
            )
            .subscribe();
    }

    onDeleteCodigoConfeccionImportacionLugarDestino($event: number): void {
        this.confirmationService.confirm({
            message: 'Va a eliminar todos los datos correspondientes al Registro Sanitario del Lugar de Destino, ¿desea continuar?',
            accept: () => {
                this.deleteDeleteCodigoConfeccionImportacionLugarDestino($event);
            },
        });
    }

    private deleteDeleteCodigoConfeccionImportacionLugarDestino(idRegistroSanitario: number): void {
        this.importadorLugarDestinoService
            .deleteRegistroSanitarioLugarDestinoByIdSolicitudAsync(idRegistroSanitario)
            .pipe(
                tap(() => {
                    this.getSolicitud();
                    this.addSuccessMessage('El Registro Sanitario ha sido eliminado con éxito');
                }),
                catchError(error => {
                    this.catchServerError(error);
                    return of(null);
                }),
            )
            .subscribe();
    }

    onSave(): void {
        const model = { ...this.formGroup.value.basic };

        let importador = new TImportadorViewModel();
        importador.IdSolicitud = this.solicitud.Id;
        importador.Nif = model?.NIF;
        importador.NRegistro = model?.NRegistro;
        importador.Nombre = model?.Nombre;
        importador.Direccion = model?.Direccion;
        importador.Localidad = model?.Localidad;
        importador.CodigoPostalImportador = model?.CodigoPostalImportador;
        if (!this.esImportadorExtranjero) {
            importador.IdPaisImportador = EnumIdsTcPais.ID_ESPANA;
        } else {
            importador.IdPaisImportador = model?.IdPaisImportador;
        }
        importador.RefTraces = model?.RefTraces;
        importador.TipoRefTraces = model?.TipoRefTraces;
        importador.OperadorTraces = model?.OperadorTraces;
        importador.TipoOperador = model?.TipoOperador;
        importador.RegistroSanitario = model?.RegistroSanitario;
        importador.IdRegistroSanitario = model?.IdRegistroSanitario;
        //importador.IdConfiguracion = this.idConfiguracion;

        let lugarDestino = new TImportadorLugarDestinoViewModel();
        lugarDestino.IdSolicitud = this.solicitud.Id;
        lugarDestino.Nif = model?.NIFImpLugarDestino;
        lugarDestino.NRegistro = model?.NRegistroImpLugarDestino;
        lugarDestino.Nombre = model?.NombreImpLugarDestino;
        lugarDestino.Direccion = model?.DireccionImpLugarDestino;
        lugarDestino.Localidad = model?.LocalidadImpLugarDestino;
        lugarDestino.CodigoPostalImpLugarDestino = model?.CodigoPostalImpLugarDestino;
        //if (!this.esImportadorExtranjero) {
        //    lugarDestino.IdPaisImpLugarDestino = EnumIdsTcPais.ID_ESPANA;
        //} else {
        lugarDestino.IdPaisImpLugarDestino = model?.IdPaisImpLugarDestino;
        //}

        lugarDestino.RefTraces = model?.RefTracesImpLugarDestino;
        lugarDestino.TipoRefTraces = model?.TipoRefTracesImpLugarDestino;
        lugarDestino.OperadorTraces = model?.OperadorTracesImpLugarDestino;
        lugarDestino.TipoOperador = model?.TipoOperadorImpLugarDestino;
        lugarDestino.RegistroSanitario = model?.RegistroSanitarioImpLugarDestino;
        lugarDestino.IdRegistroSanitario = model?.IdRegistroSanitarioImpLugarDestino;
        //lugarDestino.IdConfiguracion = this.idConfiguracion;

        if (!this.form.valid) {
            this.form.markAllAsTouched();
            this.addErrorMessage('Revise los campos obligatorios');

            return;
        }

        if (model?.NIF !== null && model?.NIF !== undefined && model?.NIF !== '') {
            this.visibilitySpinner = true;
            this.importadorLugarDestinoService
                .saveImportador(importador)
                .pipe(
                    tap(() => {
                        this.visibilitySpinner = false;
                        this.addSuccessMessage('Importador guardado correctamente');
                        // this.getSolicitud();
                    }),
                    catchError(error => {
                        this.catchServerError(error);
                        this.visibilitySpinner = false;
                        return of([]);
                    }),
                )
                .subscribe();
        }

        if (model?.NIFImpLugarDestino !== null && model?.NIFImpLugarDestino !== undefined && model?.NIFImpLugarDestino !== '') {
            this.visibilitySpinner = true;
            this.importadorLugarDestinoService
                .saveImportadorLugarDestino(lugarDestino)
                .pipe(
                    tap(() => {
                        this.visibilitySpinner = false;
                        this.addSuccessMessage('Lugar Destino guardado correctamente');
                        this.getSolicitud();
                    }),
                    catchError(error => {
                        this.catchServerError(error);
                        this.visibilitySpinner = false;
                        return of([]);
                    }),
                )
                .subscribe();
        }
    }

    onBack() {
        this.router.navigate([`/importacion/solicitud/productos/${this.IdSolicitud}`]);
    }

    // Condiciones para el importador nacional
    // PF siempre es Predua
    get nombreImportadorRequired(): boolean {
        return (this.esPasajeros || this.esPredua) && !this.esPrevia;
    }
    get nombreImpLugarDestinoRequired(): boolean {
        return this.tieneLugarDestinoImpor && this.esPredua && !this.esPrevia;
    }

    get formInvalid(): boolean {
        // Los campos obligatorios varían, tengo que ver esto con @agaro
        return !this.formGroup.valid || !this.formGroup.dirty || this.formGroup.pristine;
    }

    private DisableControlsConsulta(): void {
        // Deshabilitar controles en el formulario principal
        this.disableControlsInGroup(this.form);

        // Si hay grupos dentro de tu formulario, también deshabilítalos de manera recursiva
        if (this.form.controls['basic']) {
            this.disableControlsInGroup(this.form.controls['basic']);
        }
    }

    private disableControlsInGroup(group: AbstractControl): void {
        if (group instanceof FormGroup) {
            // Recorre los controles dentro de un FormGroup
            Object.keys(group.controls).forEach(controlName => {
                const control = group.controls[controlName];
                if (control instanceof FormControl) {
                    control.disable();
                } else if (control instanceof FormGroup || control instanceof FormArray) {
                    // Llamada recursiva si es un FormGroup o FormArray
                    this.disableControlsInGroup(control);
                }
            });
        }
    }
}
